import waterSourceApi, {
  IUpdateWaterSourcePayload,
} from '@/api/config/waterSourceApi'
import { queryKeys } from '@/constant/common'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'react-hot-toast'
import { useConfigUI } from '../../context'

async function updateWaterSource(
  payload: IUpdateWaterSourcePayload,
): Promise<void> {
  await waterSourceApi.update(payload)
}

function useEditWaterSource() {
  const queryClient = useQueryClient()
  const { closeSidebar } = useConfigUI()

  return useMutation(
    (payload: IUpdateWaterSourcePayload) => updateWaterSource(payload),
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries([queryKeys.waterSource])
        toast.success('Edit Water Source Success')
        closeSidebar()
      },
      onError: (error: any) => {
        toast.error(error?.message)
      },
    },
  )
}

export default useEditWaterSource
